/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    startedAt: z.coerce.date().default(() => new Date()),
    endedAt: z.coerce.date().nullish(),
    isActive: z.boolean().default(true),
    sessionData: z.any(),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    startedAt: z.coerce.date(),
    endedAt: z.coerce.date().nullish(),
    isActive: z.boolean(),
    sessionData: z.any(),
}
).strict();
const relationSchema = z.object({
    impersonatorUser: z.record(z.string(), z.unknown()),
    impersonatedUser: z.record(z.string(), z.unknown()),
}
);
const fkSchema = z.object({
    impersonator: z.string(),
    impersonated: z.string(),
}
);

/**
 * `ImpersonationSession` schema excluding foreign keys and relations.
 */
export const ImpersonationSessionScalarSchema = baseSchema;


/**
 * `ImpersonationSession` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const ImpersonationSessionSchema = ImpersonationSessionScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const ImpersonationSessionPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const ImpersonationSessionPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    startedAt: z.coerce.date(),
    endedAt: z.coerce.date().nullish(),
    isActive: z.boolean(),
    sessionData: z.any()
}).partial().passthrough();


/**
 * `ImpersonationSession` schema for create operations excluding foreign keys and relations.
 */
export const ImpersonationSessionCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, startedAt: true, isActive: true
});


/**
 * `ImpersonationSession` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const ImpersonationSessionCreateSchema = ImpersonationSessionCreateScalarSchema.merge(fkSchema);


/**
 * `ImpersonationSession` schema for update operations excluding foreign keys and relations.
 */
export const ImpersonationSessionUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `ImpersonationSession` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const ImpersonationSessionUpdateSchema = ImpersonationSessionUpdateScalarSchema.merge(fkSchema.partial());

